import React from "react";
import { Modal, Button } from "react-bootstrap";
import { ERROR_MESSAGE } from "store/auth";
import useRouter from "util/useRouter";

import "./styles.css";

const SessionExpiredModal = props => {
  const { history } = useRouter();
  const { show } = props;
  const message = localStorage.getItem(ERROR_MESSAGE);

  return (
    <>
      <Modal className="Expired" show={show}>
        <Modal.Header>Sessão Expirada</Modal.Header>
        <Modal.Body>
          {message}
          <Button className="Button" onClick={() => history.push("/login")}>
            Login
          </Button>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SessionExpiredModal;
